"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.folders = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var folders = function folders(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'folders-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M4 4.79761C3.86193 4.79761 3.75 4.90954 3.75 5.04761V10.0476C3.75 10.1857 3.86193 10.2976 4 10.2976H12C12.1357 10.2976 12.2463 10.1893 12.2499 10.0548L12.25 10.0476V6.07488C12.25 5.93681 12.1381 5.82488 12 5.82488H8C7.79759 5.82488 7.60377 5.74307 7.46258 5.59803L6.68341 4.79761H4ZM2.25 5.04761C2.25 4.08111 3.0335 3.29761 4 3.29761H7C7.20241 3.29761 7.39623 3.37942 7.53742 3.52446L8.31659 4.32488H12C12.9665 4.32488 13.75 5.10838 13.75 6.07488V6.32488H14C14.9665 6.32488 15.75 7.10838 15.75 8.07488V9.32488H16C16.9665 9.32488 17.75 10.1084 17.75 11.0749V15.0476C17.75 16.0141 16.9665 16.7976 16 16.7976H8C7.0335 16.7976 6.25 16.0141 6.25 15.0476V14.2976H6C5.0335 14.2976 4.25 13.5141 4.25 12.5476V11.7976H4C3.0335 11.7976 2.25 11.0141 2.25 10.0476V5.04761ZM5.75 11.7976V12.5476C5.75 12.6857 5.86193 12.7976 6 12.7976H14C14.1381 12.7976 14.25 12.6857 14.25 12.5476V8.07488C14.25 7.93681 14.1381 7.82488 14 7.82488H13.75V10.0476C13.75 10.0634 13.7498 10.0792 13.7494 10.095C13.7241 11.0398 12.9507 11.7976 12 11.7976H5.75ZM7.75 14.2976V15.0476C7.75 15.1857 7.86193 15.2976 8 15.2976H16C16.1381 15.2976 16.25 15.1857 16.25 15.0476V11.0749C16.25 10.9368 16.1381 10.8249 16 10.8249H15.75V12.5476C15.75 13.5141 14.9665 14.2976 14 14.2976H7.75Z',
    fill: '#4B5563'
  }));
};

exports.folders = folders;